<template>
  <div class="liu" v-wechat-title="'身份认证'">
    <!-- 提示信息 -->
    <div class="tips page-padding-l-r">
      <span class="txt">请拍摄本人的身份证证件</span>
    </div>
    <!-- 身份证 -->
    <div class="flex-s padding-t-10 padding-b-10 page-padding-l-r color-f-bg">
      <!-- Label-->
      <div style="width: 95px;">
        <span>证件照</span>
      </div>
      <!-- 头像页 -->
      <div class="align-center title-5 say-color" style="margin-right: 0.5rem;">
        <div class="id-card-style" @click="onCameraImgClick('renXiang')">
          <img v-if="renXiang.webUrl" class="img" :src="renXiang.webUrl" />
          <svg-icon v-else class-name="img" icon-class="authenticate-headshot" />
        </div>
        <div class="id-card-tips">头像页</div>
      </div>
      <!-- 国徽页 -->
      <div class="align-center title-5 say-color">
        <div class="id-card-style" @click="onCameraImgClick('guoHui')">
          <img v-if="guoHui.webUrl" class="img" :src="guoHui.webUrl" />
          <svg-icon v-else class-name="img" icon-class="authenticate-emblem" />
        </div>
        <div class="id-card-tips">国徽页</div>
      </div>
    </div>
    <!-- 提交按钮 -->
    <div class="padding-t-10 padding-b-10 page-padding-l-r">
      <mt-button type="primary" size="large" :disabled="!renXiang.webUrl || !guoHui.webUrl"
        @click="onSubmitBtnClick">提交</mt-button>
    </div>
  </div>
</template>

<script>
/* global wx */

import SvgIcon from '@/components/SvgIcon';
import { UploadIdCardImg } from '@/api/weChat.js';
import { CusAlert, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'UpdateIdCard',
  components: { SvgIcon },
  data() {
    return {
      // 身份证人像面
      renXiang: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
      // 身份证国徽面
      guoHui: {
        type: '',
        base64: '',
        fileUrl: '',
        webUrl: '',
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      const imgType = this.$route.query.imgtype;
      if (imgType) {
        this.renXiang.webUrl = decodeURIComponent(this.$route.query.rxweburl).replace('|', '?');
        this.guoHui.webUrl = decodeURIComponent(this.$route.query.ghweburl).replace('|', '?');
      }
    });
  },
  methods: {
    // 拍照组件点击事件
    onCameraImgClick(type) {
      switch (type) {
        case "renXiang":
        case "guoHui":
          const data = this.createPostMessage(type);
          wx.miniProgram.postMessage({ data });
          wx.miniProgram.redirectTo({
            url: '/pages/media/media',
          });
          break;
      }
    },
    // 提交数据按钮点击
    onSubmitBtnClick() {
      CusLoadingOpen();
      UploadIdCardImg({
        idcardFrontUrl: this.renXiang.webUrl,
        idCardBackUrl: this.guoHui.webUrl,
      })
        .then(res => {
          CusLoadingClose();
          // 1.向小程序发消息，更新状态
          wx.miniProgram.postMessage({ data: { page: "refresh" } });
          if (res.code === 0) {
            // 2.跳转回小程序
            wx.miniProgram.navigateBack();
          } else {
            CusAlert(res.msg, () => wx.miniProgram.navigateBack());
          }
        })
        .catch(() => {
          CusLoadingClose();
        });
    },
    // 重新拍照
    resetCameraInfo(name) {
      this[name].base64 = '';
      this[name].fileUrl = '';
      this[name].webUrl = '';
    },
    // 创建向小程序传递消息的参数对象
    createPostMessage(imgTypeStr) {
      return {
        page: 'media',
        h5Page: 'UpdateIdCard',
        imgType: imgTypeStr,
        rxWebUrl: encodeURIComponent(this.renXiang.webUrl.replace('?', '|')),
        ghWebUrl: encodeURIComponent(this.guoHui.webUrl.replace('?', '|')),
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.tips {
  line-height: 1;
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;

  .txt {
    font-size: $title5;
    color: $explain-color;
  }
}

.id-card-style {
  width: 6rem;
  height: 4rem;
  vertical-align: middle;
  overflow: hidden;
  @include dynamic-color;

  .img {
    width: 100%;
    height: 100%;
  }
}

.id-card-tips {
  line-height: 1;
  padding-top: 0.2rem;
}
</style>
